import { http, createPublicClient } from 'viem'
import { arbitrum } from 'viem/chains'

// Shared read-only Arbitrum client. Use this for any `readContract` call
// against Arbitrum — never `createPublicClient` ad-hoc, and never reuse
// the Polygon-bound `publicClient` from WalletContext (it returns "0x"
// for Arbitrum addresses and throws ContractFunctionZeroDataError).
export const arbitrumReadClient = createPublicClient({
	chain: arbitrum,
	transport: http(
		process.env.NEXT_PUBLIC_ALCHEMY_API_KEY
			? `https://arb-mainnet.g.alchemy.com/v2/${process.env.NEXT_PUBLIC_ALCHEMY_API_KEY}`
			: 'https://arb1.arbitrum.io/rpc'
	),
})
